import { type FC, useCallback } from "react";

import { useV3Routes } from "../../core/routes/hooks";
import { type CreatedOrganization } from "../../shared/hooks";
import { Feature } from "../../shared/models";

import { CreateOrganizationAndLensSpacePageContainer } from "./CreateOrganizationAndLensSpacePage";

export const WebLensCreateOrganizationAndLensSpace: FC = () => {
    const { goToContainerFeature } = useV3Routes();

    // The new org's only folder auto-selects on the Web Lenses page.
    const onCreationSuccess = useCallback(
        (organization: CreatedOrganization) => {
            goToContainerFeature(Feature.webLenses, organization.id);
        },
        [goToContainerFeature],
    );

    return (
        <CreateOrganizationAndLensSpacePageContainer
            onCreationSuccess={onCreationSuccess}
            forceUseDefaultNames={true}
        />
    );
};
